var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNativePlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 59,
    viewBox: "0 0 53 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1772_11861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1292 1.76436C28.3446 0.156669 24.9138 0.156671 22.1292 1.76437L4.87109 11.7283C2.08648 13.336 0.371094 16.3072 0.371094 19.5225V39.4505C0.371094 42.6658 2.08649 45.637 4.8711 47.2447L22.1292 57.2086C24.9138 58.8163 28.3446 58.8163 31.1292 57.2086L48.3872 47.2447C51.1718 45.637 52.8872 42.6658 52.8872 39.4504V19.5225C52.8872 16.3072 51.1718 13.336 48.3872 11.7283L31.1292 1.76436ZM26.6321 41.754C33.8121 39.4486 38.3162 28.9356 38.8563 23.4835C36.6288 19.4271 30.4431 17.2193 26.6321 17.2193C22.8211 17.2193 16.6355 19.4271 14.4079 23.4835C14.9481 28.9356 19.4522 39.4486 26.6321 41.754Z",
    fill: "url(#paint0_linear_1772_11861)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1772_11861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.30469 -0.207031H53.4016V58.3644H-4.30469V-0.207031Z",
    fill: "url(#paint1_linear_1772_11861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7226 25.8771C47.2508 44.6286 33.023 44.3639 26.5926 41.7365L15.3485 21.5211L6.84375 25.8771V46.8274L21.0139 58.1711L61.19 64.8737C61.3974 44.0617 60.1943 7.12559 53.7226 25.8771Z",
    fill: "url(#paint2_linear_1772_11861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8547 23.482C34.8454 5.27826 15.6516 4.87322 6.26101 6.81455C-2.80216 7.27448 -6.45494 20.641 -7.14844 27.2667L-2.81409 51.5113L14.4762 52.8234C6.13279 39.929 10.9374 27.6807 14.4138 23.482L38.8547 23.482Z",
    fill: "url(#paint3_linear_1772_11861)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_11861",
    x1: 26.6292,
    y1: 0.558594,
    x2: 26.6292,
    y2: 58.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7872F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_11861",
    x1: 35.5218,
    y1: 8.81616,
    x2: 27.2246,
    y2: 43.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054746,
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1772_11861",
    x1: 51.1299,
    y1: 39.9304,
    x2: 9.02195,
    y2: 36.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1772_11861",
    x1: 4.77081,
    y1: 29.265,
    x2: 32.1514,
    y2: 15.5057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativePlatform);
export default __webpack_public_path__ + "static/media/NativePlatform.cf2b6f72dfd5c0ccbe30c5beac159195.svg";
export { ForwardRef as ReactComponent };